import { render, staticRenderFns } from "./DisputeSelect.vue?vue&type=template&id=04924c1a&"
import script from "./DisputeSelect.vue?vue&type=script&lang=js&"
export * from "./DisputeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DisputeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports